<template>
  <div class="quote-clipboard">
    <div class="title">
      <h3>My Clipboard</h3>
      <span class="count">{{ count }} {{ label }}</span>
    </div>
    <div class="skus">
      <!-- Loop through all records -->
      <div class="quote-sku" v-for="(record, index) in paginated" :key="index">
        <!-- Checkbox -->
        <input
          v-show="isWorkingWithCollection"
          type="checkbox"
          :name="record.id"
          :checked="quantityGreaterThanZero(record)"
          :value="quantityGreaterThanZero(record)"
          @change="handleCheck($event, record.id)"
        />

        <a class="summary-sku quote" :href="`/config/clipboard/${record.uid}`">
          <!-- Product Details -->
          <div class="sku_product">
            <div class="info">
              <img
                :src="record.product.thumbnail.src.url"
                :srcset="record.product.thumbnail.srcset"
                sizes="(max-width: 20.625em) 21vw, (max-width: 34em) 13vw, (max-width: 46.875em) 9vw, (max-width: 61.9375em) 8vw, (max-width: 68.75em) 7vw, 70px"
                :alt="`Image of ${record.product.title}`"
              />
              <div class="txt">
                <h4>{{ record.product.title }}</h4>
                <h6>QTY: {{ evaluateQuantity(record) }}</h6>
              </div>
            </div>

            <!-- Action Buttons -->
            <div class="actions">
              <button type="button" @click="decrement(record.id)" class="minus">
                &minus;
              </button>
              <span class="qty">
                <input
                  type="number"
                  :class="{ small: recordDigitCountOver(record.id, 2) }"
                  min="0"
                  required
                  :value="selections[record.id] ? selections[record.id].qty : 0"
                  @input="updateSelectTracker($event, record.id)"
                  @change="updateSelectTracker($event, record.id)"
                />
              </span>
              <button type="button" @click="increment(record.id)" class="plus">
                &plus;
              </button>
            </div>
          </div>
          <div class="sku_details">
            <!-- Sku Component -->
            <sku
              simplified="true"
              :product="record.product"
              :selections="record.selections"
            />
          </div>
        </a>
      </div>
    </div>
    <!-- Pagination -->
    <div v-show="isWorkingWithCollection" class="skus-pagination">
      <pagination
        :records="clipboard"
        @return-pagination="setPaginated"
      />
    </div>
  </div>
</template>

<script>
import Pagination from "../Pagination";
import Sku from "../Sku";

export default {
  components: {
    Pagination,
    Sku,
  },
  props: ["clipboard"],
  watch: {
    //
  },
  data() {
    return {
      selections: [],
      paginated: [],
      page: 1,
    };
  },
  mounted() {
    if (this.paginated.length === 1) {
      this.updateSelections(this.paginated[0].id, 1);
    }
  },
  computed: {
    isWorkingWithCollection() {
      return this.clipboard.length > 1;
    },
    count() {
      return this.clipboard.length;
    },
    label() {
      return this.count > 1 || this.count === 0 ? "SKU" : "SKUs";
    },
  },
  methods: {
    updateSelectTracker(event, recordId) {
      if (this.selections[recordId]) {
        if (event.target.value == "" || event.target.value <= 0) {
          this.selections[recordId].qty = 0;
          return;
        }
        this.selections[recordId].qty = event.target.value;
      } else {
        event.target.value = 0;
      }
    },
    setPaginated(object) {
      this.paginated = object.results;
      this.page = object.page;
    },
    handleCheck($event, index) {
      let value = $event.target.checked ? 1 : 0;
      this.updateSelections(index, value);
    },
    increment(index) {
      let value = this.selections[index]
        ? Number(this.selections[index].qty) + 1
        : 1;
      this.updateSelections(index, value);
    },
    decrement(index) {
      let value = this.selections[index]
        ? Number(this.selections[index].qty) - 1
        : 0;
      if (value >= 0) {
        this.updateSelections(index, value);
      }
    },
    updateSelections(index, value) {
      let record =
        this.clipboard.length == 1
          ? this.clipboard[0]
          : this.clipboard.find((record) => {
              return record.id == index;
            });

      let skuString = `${record.product.family}-${record.product.model}-${record.product.type}`;

      record.product.steps.forEach((step) => {
        let value =
          record.selections[step.id] !== undefined
            ? record.selections[step.id].external
            : "???";
        skuString = skuString.concat(`-${value}`);
      });

      this.selections = Object.assign({}, this.selections, {
        [index]: { qty: value, sku: skuString, title: record.product.title },
      });

      this.$emit("update-selections", index, this.selections);
    },
    quantityGreaterThanZero(record) {
      return this.selections[record.id] && this.selections[record.id].qty > 0;
    },
    evaluateQuantity(record) {
      return this.selections[record.id] ? this.selections[record.id].qty : 0;
    },
    recordDigitCountOver(recordId, number = 3) {
      return this.selections[recordId]
        ? this.selections[recordId].qty.toString().length > number
        : false;
    },
  },
};
</script>
